import { getHybridApp } from '@vmos2/core';

import { openWindowBrowser } from './openWindowBrowser';

export const openGoogleMapWindow = async (url?: string) => {
  if (!url) {
    return;
  }

  const hybridApp = await getHybridApp();
  const target = hybridApp ? '_system' : '_blank';
  const windowOptions = 'noopener,noreferrer';

  openWindowBrowser(url, windowOptions, target);
};
